import { useQueryClient } from '@tanstack/react-query'

import { useIndividualsServiceDeleteV1IndividualsByIndividualIdDocumentsDrafts } from '../client/queries'
import { useIndividualsServiceGetV1IndividualsByIndividualIdKey } from '../client/queries/common'

export const useDiscardDrafts = () => {
  const queryClient = useQueryClient()

  return useIndividualsServiceDeleteV1IndividualsByIndividualIdDocumentsDrafts({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })
    },
  })
}
